import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import ComplaintList from "../components/ComplaintList";
import { DenunciaCard } from "./CompanyPage";
import { useAuth } from "../context/AuthContext";
import { obterDenuncia, obterEmpresa } from "../services/api";

// Página de UMA reclamação (permalink, RA-style): história completa (relato + resposta + réplica/tréplica +
// linha do tempo) e, no fim, "outras reclamações da empresa". Compartilhável (OG no servidor) e pública.
export default function ReclamacaoPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, isEmpresa } = useAuth();
  const [d, setD] = useState(null);
  const [erro, setErro] = useState(null);
  const [outras, setOutras] = useState([]);
  const [nomeEmpresa, setNomeEmpresa] = useState("");

  const carregar = () => {
    obterDenuncia(id)
      .then((x) => {
        setD(x);
        obterEmpresa(x.empresaId)
          .then((emp) => {
            setNomeEmpresa(emp?.empresa?.nome || x.empresa || "");
            setOutras((emp?.denuncias || []).filter((o) => o.id !== x.id));
          })
          .catch(() => { /* outras é complementar */ });
      })
      .catch((e) => setErro(e.message || "erro"));
  };

  useEffect(() => { setD(null); setErro(null); setOutras([]); window.scrollTo(0, 0); carregar(); /* eslint-disable-next-line */ }, [id]);

  const souDono = !!(isEmpresa && d && user?.empresaId === d.empresaId);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8 pb-28 md:pb-8">
        {d ? (
          <Link to={`/empresas/${d.empresaId}`} className="text-sm font-semibold text-primary hover:underline">← Voltar para {d.empresa}</Link>
        ) : (
          <Link to="/empresas" className="text-sm font-semibold text-primary hover:underline">← Ver empresas avaliadas</Link>
        )}

        {erro && (
          <div className="mt-4 rounded-xl border border-red-200 bg-red-50 p-4 text-red-700">
            <p>Não foi possível carregar este relato (pode ter sido removido).</p>
            <Link to="/" className="mt-2 inline-block font-semibold underline">Voltar ao início</Link>
          </div>
        )}
        {!erro && !d && <p className="mt-4 text-gray-500">Carregando relato…</p>}

        {d && (
          <>
            {d.empresa && (
              <p className="mt-3 text-sm text-gray-600">
                Relato sobre <Link to={`/empresas/${d.empresaId}`} className="font-semibold text-primary hover:underline">{d.empresa}</Link>
              </p>
            )}

            <div className="mt-3">
              <DenunciaCard d={d} user={user} souDono={souDono} onAcao={carregar} />
            </div>

            <div className="mt-6">
              <Link to={`/empresas/${d.empresaId}`} className="inline-flex items-center rounded-xl bg-primary px-5 py-2.5 font-semibold text-white hover:bg-primary/90">
                Ver a reputação completa da {d.empresa} →
              </Link>
            </div>

            {outras.length > 0 && (
              <section className="mt-10">
                <h2 className="text-lg md:text-xl font-bold text-text mb-3">
                  Outros relatos da {nomeEmpresa || d.empresa}
                </h2>
                <ComplaintList complaints={outras} onSelect={(o) => navigate(`/relato/${o.id}`)} pageSize={5} />
              </section>
            )}
          </>
        )}
      </main>
    </div>
  );
}
